import { post } from '../../utils/http';

// https://papi.sankuai.com/index/#/papi/project/d3fab1f7-c7cd-4ba5-8170-2d7302a37a03?apiId=f0ec9c59-3b25-4ebf-b99e-d1b8000d3434
export const revokeProject = () => post('/project/revoke', {});
// https://papi.sankuai.com/index/#/papi/project/d3fab1f7-c7cd-4ba5-8170-2d7302a37a03?apiId=092a3782-82a8-47d1-983e-77307f01e630
export const downloadProject = (data) => post('/project/download', data);
